export const LSSD_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_sheriff-ops/artifacts/x5bitwww_LSSD.png";

export const HERO_BG_URL =
  "https://static.prod-images.emergentagent.com/jobs/13698a40-423f-4d70-963b-117f60b38285/images/8609233c665cceee7d280185cb182f1b7ad012a276aa8e3e41cc9c6ee546fc8a.png";

export const RECRUITMENT_BG_URL = "/img/recruitment_bg.png";

export default function LSSDLogo({ className = "", alt = "LSSD Star" }) {
  return <img src={LSSD_LOGO_URL} alt={alt} className={className} draggable={false} />;
}
